
// 初始化 MENU_CONF 属性
const editorConfig = {                       // JS 语法
    MENU_CONF: {}

    // 其他属性...
};
// 上传图片
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF['uploadImage'] = {
    server: '/api/upload-img',
    // server: '/api/upload-img-10s', // test timeout
    // server: '/api/upload-img-failed', // test failed
    // server: '/api/xxx', // test 404

    timeout: 5 * 1000, // 5s

    fieldName: 'custom-fileName',
    meta: { token: 'xxx', a: 100 },
    metaWithUrl: true, // join params to url
    headers: { Accept: 'text/x-json' },

    maxFileSize: 10 * 1024 * 1024, // 10M

    base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb
    // 继续写其他配置...
    
    //【注意】不需要修改的不用写，wangEditor 会去 merge 当前其他配置
    // 上传之前触发
        onBeforeUpload(file) {    // JS 语法
            // file 选中的文件，格式如 { key: file }
            return file
    
            // 可以 return
            // 1. return file 或者 new 一个 file ，接下来将上传
            // 2. return false ，不上传这个 file
        },
    
        // 上传进度的回调函数
       onProgress(progress) {       // JS 语法
            // progress 是 0-100 的数字
            console.log('progress', progress)
        },
    
        // 单个文件上传成功之后
        onSuccess(file, res) {          // JS 语法
            console.log(`${file.name} 上传成功`, res)
        },
    
        // 单个文件上传失败
        onFailed(file, res) {           // JS 语法
            console.log(`${file.name} 上传失败`, res)
        },
    
        // 上传错误，或者触发 timeout 超时
        onError(file, err, res) {               // JS 语法
            console.log(`${file.name} 上传出错`, err, res)
        },
        
}

// 上传视频
editorConfig.MENU_CONF['insertVideo'] = {
    onInsertedVideo(videoNode) {
      console.log('inserted video', videoNode)
    },
};
editorConfig.MENU_CONF['uploadVideo'] = {
    server: '/api/upload-video',
    // server: '/api/upload-img-failed', // test failed
    // server: '/api/xxx', // test 404

    timeout: 5 * 1000, // 5s

    fieldName: 'custom-fileName',
    meta: { token: 'xxx', a: 100 },
    metaWithUrl: true, // join params to url
    headers: { Accept: 'text/x-json' },

    maxFileSize: 10 * 1024 * 1024, // 10M

    onBeforeUpload(file) {
      console.log('onBeforeUpload', file)

      return file // will upload this file
      // return false // prevent upload
    },
    onProgress(progress) {
      console.log('onProgress', progress)
    },
    onSuccess(file, res) {
      console.log('onSuccess', file, res)
    },
    onFailed(file, res) {
      alert(res.message)
      console.log('onFailed', file, res)
    },
    onError(file, err, res) {
      alert(err.message)
      console.error('onError', file, err, res)
    },

    // customInsert(res, insertFn) {
    //   console.log('customInsert', res)
    //   const videoInfo = res.data || {}
    //   const { url, poster } = videoInfo
    //   if (!url) throw new Error(`Video url is empty`)

    //   console.log('Your video url ', url)
    //   insertFn(url, poster)
    // },

    // customUpload(file, insertFn) {
    //   console.log('customUpload', file)

    //   return new Promise((resolve) => {
    //     // Simulate async insert video
    //     setTimeout(() => {
    //       const src = `https://www.w3school.com.cn/i/movie.ogg`
    //       const poster = 'https://www.baidu.com/img/flexible/logo/pc/result@2.png'
    //       insertFn(src, poster)
    //       resolve('ok')
    //     }, 500)
    //   })
    // },

    // customBrowseAndUpload(insertFn) {
    //   alert('Custom browse and upload')

    //   // Simulate async insert video
    //   setTimeout(() => {
    //     const src = '<iframe src="//player.bilibili.com/player.html?aid=250348909&bvid=BV1Pv411w7Xr&cid=401518678&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>'
    //     insertFn(src, '')
    //   }, 500)
    // },
  };
// 修改 otherMenuKey 菜单配置
editorConfig.MENU_CONF['otherMenuKey'] = {
    // 配置
}
export {
    editorConfig
}
